import { render, staticRenderFns } from "./MultiselectItem.vue?vue&type=template&id=5f2479be&scoped=true&"
import script from "./MultiselectItem.vue?vue&type=script&lang=js&"
export * from "./MultiselectItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectItem.vue?vue&type=style&index=0&id=5f2479be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2479be",
  null
  
)

export default component.exports